import React from "react";

import { Card, Col, Form, Row } from "react-bootstrap";

import ContactFormReferenceSection from "@/components/contact/elements/ContactFormReference.component";
import { getCurrentLang } from "@/utils/Local";

import useContactContext from "../../../hooks/useContactContext";
import i18n from "../../../i18n";
import ContactFormLocationSection from "../elements/ContactFormLocationSection.component";
import ContactFormPhoneSection from "../elements/ContactFormPhoneSection.component";
import ContactFormProjectInfoSection from "../elements/ContactFormProjectInfoSection.component";

const ContactFormAffordable = () => {
  const { t } = i18n;
  const { onSubmit, methods, submitting } = useContactContext();

  return (
    <Form className="w-100" onSubmit={methods.handleSubmit(onSubmit)}>
      <fieldset disabled={submitting}>
        <input
          type="hidden"
          {...methods.register("kind")}
          label={null}
          value="affordable"
        />
        <input
          type="hidden"
          {...methods.register("lang")}
          label={null}
          value={getCurrentLang()}
        />
        <Card>
          <Card.Body>
            <Row>
              <Col xs={12}>
                <Card.Title>{t("Primary Information")}</Card.Title>
              </Col>

              <Col xs={12}>
                <Row>
                  <Col lg={6} xs={12}>
                    <Form.Group className="mb-3" controlId="name">
                      <Form.Label>{t("Full name")}</Form.Label>
                      <Form.Control
                        type="text"
                        {...methods.register("name")}
                        isInvalid={!!methods.formState.errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(methods.formState.errors.name?.message)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} xs={12}>
                    <Form.Group className="mb-3" controlId="company">
                      <Form.Label>
                        {t("Organization / Municipality")}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        {...methods.register("company")}
                        isInvalid={!!methods.formState.errors.company}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(methods.formState.errors.company?.message)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} xs={12}>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>{t("Email")}</Form.Label>
                      <Form.Control
                        type="email"
                        {...methods.register("email")}
                        isInvalid={!!methods.formState.errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(methods.formState.errors.email?.message)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} xs={12}>
                    <ContactFormPhoneSection
                      control={methods.control}
                      errors={methods.formState.errors}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card className="mt-4">
          <Card.Body>
            <ContactFormLocationSection methods={methods} />
          </Card.Body>
        </Card>

        <ContactFormProjectInfoSection methods={methods} />

        <ContactFormReferenceSection methods={methods} />
      </fieldset>
    </Form>
  );
};

export default ContactFormAffordable;
